// Mirrors the iOS SkinScores / ScanResult shape so the gateway response decodes 1:1.

export interface RegionalScore {
  overall: number;
  regions?: Record<string, number>;
}
export interface SimpleScore {
  overall: number;
}

export interface SkinScores {
  wrinkles: RegionalScore;
  pigmentation: RegionalScore;
  redness: SimpleScore;
  texture: SimpleScore;
  pores: RegionalScore;
  dark_circles: SimpleScore;
  hydration?: SimpleScore;
  acne?: SimpleScore;
  oiliness?: SimpleScore;
  firmness?: SimpleScore;
}

export type Severity = 'high' | 'moderate' | 'healthy';

export interface SkinFactor {
  name: string;
  icon: string; // mapped to lucide / svg name
  severity: Severity;
  insight: string;
}

export interface RoutineStep {
  name: string;
  detail: string;
  slug: string;
}

export interface ClaudeRoutineStep {
  category: string;
  ingredient: string;
  concentrationOrForm?: string;
  rationale: string;
}

export interface ClaudeRoutine {
  amSteps: ClaudeRoutineStep[];
  pmSteps: ClaudeRoutineStep[];
  summary: string;
  warnings: string[];
  expectedResultsTimeline: string;
}

export interface ScanResult {
  skinAge: number;
  realAge: number;
  scores: SkinScores;
  factors: SkinFactor[];
  amRoutine: RoutineStep[];
  pmRoutine: RoutineStep[];
  priorityIngredients: string[];
  priorityIngredientSlugs: string[];
  summary: string;
  expectedTimeline: string;
  warnings: string[];
}

export type SkinGoal =
  | 'wrinkles'
  | 'pigmentation'
  | 'hydration'
  | 'texture'
  | 'acne'
  | 'redness'
  | 'pores';

export const SKIN_GOALS: { id: SkinGoal; label: string }[] = [
  { id: 'wrinkles', label: 'Anti-aging' },
  { id: 'pigmentation', label: 'Even tone' },
  { id: 'hydration', label: 'Hydration' },
  { id: 'texture', label: 'Texture' },
  { id: 'acne', label: 'Acne' },
  { id: 'redness', label: 'Redness' },
  { id: 'pores', label: 'Pores' },
];
